import React                              from 'react';
import classNames                         from 'classnames';
import { WithStyle }                      from 'rewire-ui';
import { Theme }                          from '@material-ui/core/styles';
import Typography                         from '@material-ui/core/Typography';
import Icon                               from '@material-ui/icons/Brightness1';
import { BatchStatusType, toBatchStatus } from '../DataTypes';
import { withStyles }                     from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    height: '16px',
    width: '16px',
    alignSelf: 'center',
  },
  notInBatch: {
    color: 'darkorange',
  },
  open: {
    color: 'black'
  },
  closed: {
    color: 'slategray'
  },
  exported: {
    color: 'green'
  }
});

interface IBatchLabelProps {
  className?:  string;
  batchStatus: BatchStatusType;
  batchName?:  string;
  showLabel?:  boolean;
}

type BatchLabelProps = WithStyle<ReturnType<typeof styles>, IBatchLabelProps>;

class BatchStatusLabel extends React.PureComponent<BatchLabelProps> {
  batchClass(batchStatus: BatchStatusType, classes: any): string {
    switch (batchStatus) {
      case 'not_in_batch': return classes.notInBatch;
      case 'closed':       return classes.closed;
      case 'exported':     return classes.exported;
    }
  }

  batchLabel(batchStatus: BatchStatusType, batchName?: string) {
    if (!batchName || (batchStatus === 'not_in_batch')) return toBatchStatus(batchStatus);

    return `${batchName}: ${toBatchStatus(batchStatus)}`;
  }

  render() {
    const { classes, className, batchStatus, batchName, showLabel } = this.props;
    const batchClass                                                = this.batchClass(batchStatus, classes);
    const batchLabel                                                = showLabel ? this.batchLabel(batchStatus, batchName) : null;

    if (!batchStatus) return null;

    return <Typography display='inline' variant='button' className={classNames(className, classes.root)}><Icon className={classNames(classes.icon, batchClass)} />&nbsp;<span className={batchClass}>{batchLabel}</span></Typography>;
  }
}

export default withStyles<IBatchLabelProps>(styles, BatchStatusLabel);